import { useState } from 'react';

import { Warrior } from '~/../api/common.types';
import NamingDetails from '~/components/naming/NamingDetails';
import NamingSuccess from '~/components/naming/NamingSuccess';
import {
  randomizePlaceOrAdjective,
  randomizeSingleName,
} from '~/components/naming/utils';
import Shuffle from '~/components/svgs/Shuffle';
import { useGameAuthentication } from '~/contextProviders/GameAuthenticationProvider';
import { useNameWarrior } from '~/hooks/name/useNameWarrior';
import { getCurrentWarrior, isWarriorNamed } from '~/utils/utils';

function TwoName({ warrior }: { warrior: Warrior | undefined }) {
  const [value, setValue] = useState('');
  const [valueTwo, setValueTwo] = useState('');
  const [label, setLabel] = useState('');
  const [errorMsg, setErrorMessage] = useState('');
  const [successName, setSuccessName] = useState('');
  const { accessToken } = useGameAuthentication();
  const {
    mutate: setNameWarriorMutation,
    isLoading,
    isSuccess,
    isError,
  } = useNameWarrior();

  if (!warrior) {
    return <></>;
  }

  const warriorData = getCurrentWarrior(warrior);
  const isNamed = isWarriorNamed(warrior.warrior_json.name, warrior.warrior_id);

  const handleSubmit = (event) => {
    event.preventDefault();
    setNameWarriorMutation(
      {
        id: warrior.warrior_id,
        names: [value, label, valueTwo], // pass names as array
        token: accessToken,
      },
      {
        onSuccess: (data) => {
          setSuccessName(data.name);
          console.log('data on success', data);
        },
        onError: (err: any) => {
          if (err?.response?.data?.errors) {
            const error = err.response.data['errors'][0];
            if (error?.code === 'naming:already-named') {
              setErrorMessage('Warrior has already been named');
            } else if (error?.code === 'naming:name-unavailable') {
              setErrorMessage('Name is already taken');
            } else {
              setErrorMessage('Something went wrong');
            }
          }
        },
      }
    );
  };
  if (isSuccess) {
    return <NamingSuccess warrior={warriorData} name={successName} />;
  }

  const randomLabel = () => {
    const labels = ['The', 'From', 'Who', 'Of', 'In', ''];
    const randomIndex = Math.floor(Math.random() * labels.length);
    return labels[randomIndex];
  };

  const handleLabelClick = (labelValue) => {
    if (labelValue === label) {
      setLabel('');
    } else {
      setLabel(labelValue);
    }
  };

  const handleRandomize = () => {
    const name = randomizeSingleName(warriorData.level);
    const placeOrAdjective = randomizePlaceOrAdjective(warriorData.level);
    const labelRandom = randomLabel();
    setValue(name);
    setLabel(labelRandom);
    setValueTwo(placeOrAdjective);
  };
  return (
    <div className="name-warrior--wrapper">
      <div className="warrior-name mb-space-m">
        <h2 className="warrior-name__text">
          {isNamed ? warriorData.name : `${value} ${label} ${valueTwo}`}
        </h2>
        <div className="warrior-name__media">
          <img
            src={
              warriorData.dead ?
                warriorData.images.dead :
                warriorData.images.notActive
            }
            alt={`Warrior image for ${warriorData.name}`}
            className={warriorData.dead ? 'warrior-name--dead' : ''}
          />
        </div>
        {!isNamed && <h4>{warriorData.name}</h4>}
        <NamingDetails warrior={warriorData} />
      </div>

      {!isNamed && (
        <>
          <p className="warrior-name__desc mb-space-s">
            {`Your Warrior is Level ${warriorData.level}. You get two names.`}
            <br />
            Up to 12 characters each.
          </p>

          <form className="form--naming" action="" onSubmit={handleSubmit}>
            <input
              className="mb-space-xs"
              type="text"
              value={value}
              maxLength={12}
              onChange={(e) => setValue(e.target.value)}
            />

            <div className="radio-button-grid mb-space-xs">
              <div className="radio-button radio-active">
                <input
                  type="radio"
                  name="name-connector"
                  id={`${warrior.warrior_id}-the`}
                  checked={label == 'The'}
                  onClick={() => handleLabelClick('The')}
                />
                <label htmlFor={`${warrior.warrior_id}-the`}>The</label>
              </div>
              <div className="radio-button">
                <input
                  type="radio"
                  name="name-connector"
                  id={`${warrior.warrior_id}-from`}
                  checked={label == 'From'}
                  onClick={() => handleLabelClick('From')}
                />
                <label htmlFor={`${warrior.warrior_id}-from`}>From</label>
              </div>
              <div className="radio-button">
                <input
                  type="radio"
                  name="name-connector"
                  id={`${warrior.warrior_id}-who`}
                  checked={label == 'Who'}
                  onClick={() => handleLabelClick('Who')}
                />
                <label htmlFor={`${warrior.warrior_id}-who`}>Who</label>
              </div>
              <div className="radio-button">
                <input
                  type="radio"
                  name="name-connector"
                  id={`${warrior.warrior_id}-of`}
                  checked={label == 'Of'}
                  onClick={() => handleLabelClick('Of')}
                />
                <label htmlFor={`${warrior.warrior_id}-of`}>Of</label>
              </div>
              <div className="radio-button">
                <input
                  type="radio"
                  name="name-connector"
                  id={`${warrior.warrior_id}-in`}
                  checked={label == 'In'}
                  onClick={() => handleLabelClick('In')}
                />
                <label htmlFor={`${warrior.warrior_id}-in`}>In</label>
              </div>
            </div>

            <input
              className="mb-space-xs"
              type="text"
              maxLength={12}
              value={valueTwo}
              onChange={(e) => setValueTwo(e.target.value)}
            />

            <div className="button-row">
              <button
                className="button"
                type="submit"
                disabled={isLoading || !(value || valueTwo) ? true : false}
              >
                {isLoading ? 'Dubbing...' : 'I Dub Thee'}
              </button>
              <button
                className="dice--wrapper"
                onClick={handleRandomize}
                type="button"
              >
                <Shuffle />
              </button>
            </div>
            {isError && <div className="name-error">{errorMsg}</div>}
          </form>
        </>
      )}
    </div>
  );
}

export default TwoName;
